export var RouteNameEnum;
(function (RouteNameEnum) {
    RouteNameEnum["HOME"] = "home";
    RouteNameEnum["LOGIN"] = "login";
    RouteNameEnum["FORGOT_PASSWORD"] = "forgot-password";
    RouteNameEnum["RESET_PASSWORD"] = "reset-password";
    RouteNameEnum["SET_MFA"] = "set-mfa";
    RouteNameEnum["PAGE_NOT_FOUND"] = "404";
    RouteNameEnum["PAGE_OFFLINE"] = "api-offline";
    RouteNameEnum["CURRICULUM"] = "curriculum";
    RouteNameEnum["INSIGHTS"] = "insights";
    RouteNameEnum["INSIGHTS_STUDENT_OVERVIEW"] = "insights-student-overview";
    RouteNameEnum["STUDENT_FINISHED"] = "student.finished";
})(RouteNameEnum || (RouteNameEnum = {}));
